import { Modal } from 'carbon-components-react';
import CustomButton from '../../custom-button/custom-btn.component';
import './confirm-modal.style.scss';

export function ConfirmModal({
  isOpen,
  closeModal,
  onClick,
  title,
  description,
  isLoading,
  disabled = false,
  actionText,
  secondaryActionText = 'CANCEL',
  errorMessage = null,
  actionBtnClasses = 'success',
  secondaryBtnClasses = 'danger',
}) {
  return (
    <Modal
      className="confirm-modal"
      hasScrollingContent
      passiveModal={true}
      open={isOpen}
      modalHeading={title}
      primaryButtonDisabled={false}
    >
      <div>
        <div>{description}</div>

        {errorMessage && (
          <p className="text-14 mt-10 text-danger">{errorMessage}</p>
        )}

        <div
          style={{
            marginTop: '100px',
            display: 'flex',
            gap: '10px',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <CustomButton
            classes={`outline no-hover font-bold ${secondaryBtnClasses}`}
            style={{ flex: '1' }}
            disabled={isLoading}
            onClick={closeModal}
          >
            {secondaryActionText}
          </CustomButton>

          {onClick && (
            <CustomButton
              style={{ flex: '1' }}
              classes={`font-bold ${actionBtnClasses}`}
              disabled={disabled}
              onClick={onClick}
              isLoading={isLoading}
            >
              {actionText}
            </CustomButton>
          )}
        </div>
      </div>
    </Modal>
  );
}
